import { render, staticRenderFns } from "./ReportItemList.vue?vue&type=template&id=c0c0dc54&scoped=true"
import script from "./ReportItemList.vue?vue&type=script&lang=js"
export * from "./ReportItemList.vue?vue&type=script&lang=js"
import style0 from "./ReportItemList.vue?vue&type=style&index=0&id=c0c0dc54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0dc54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c0dc54')) {
      api.createRecord('c0c0dc54', component.options)
    } else {
      api.reload('c0c0dc54', component.options)
    }
    module.hot.accept("./ReportItemList.vue?vue&type=template&id=c0c0dc54&scoped=true", function () {
      api.rerender('c0c0dc54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/gledger/ReportItemList.vue"
export default component.exports